import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss']
})
export class InstructionsComponent implements OnInit {


  steps = [{
    img: "assets/images/icons/step-1.svg",
    title: "1. Selecciona",
    description: "el certificado a canjear"
  },
  {
    img: "assets/images/icons/step-2.svg",
    title: "2. Revisa y elige tu regalo",
    description: "de los comercios disponibles"
  },
  {
    img: "assets/images/icons/step-3.svg",
    title: "3. Espera",
    description: "el alta de tus regalos"
  },
  {
    img: "assets/images/icons/step-4.svg",
    title: "4. Disfruta",
    description: "de tus regalos"
  }];

  instructionsConf = {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    observer: true,
    watchOverflow: true,
    loop: false,
    breakpoints: {
      576: {
        slidesPerView: 2,
        slidesPerColumn: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      768: {
        slidesPerView: 2,
        slidesPerColumn: 2,
        slidesPerColumnFill: 'row',
        pagination: {
          el: '.swiper-pagination'
        }
      },
      1024: {
        slidesPerView: 4,
        slidesPerColumn: 1,
        pagination: {
          el: '.swiper-pagination'
        }
      },
    }
  };

  constructor() { }

  ngOnInit() {
  }

}
